import React, { useContext } from 'react';
import IconGold from './images/Icon_Gold.png';
import IconShop from './images/Icon_Shop.png';
import IconDashboard from './images/home.png';
import IconInventory from './images/Icon_inventory.png';
import IconIncubating from './images/Incubating.png';
import IconGathering from './images/FoodGathering.png';
import IconLottery from './images/Lottery.png';
import settingsIcon from './images/Settings.png';
import newsIcon from './images/Icon-news.png';
import { SettingsContext } from '../App';

function MenuRight({changeActiveComponent, activeComponent, toggleNews }) {
  const { toggleSettings } = useContext(SettingsContext);

  const isActive = (componentName) => {
    return activeComponent === componentName ? "active2" : "";
  };

  const renderLabel = (componentName, label) => {
    return activeComponent === componentName && <p className="menu-right-text">{label}</p>;
  };

  return (
    <div className="menu-right">
    <button className={`right-menu-button dashboard-b ${isActive('dashboard')}`} onClick={() => changeActiveComponent('dashboard')}>
      <img src={IconDashboard} alt="Dashboard icon" />
      {renderLabel('dashboard', 'HOME')}
    </button>
    <p className="menu-right-text2">GAMEPLAY</p>
    <button className={`right-menu-button inventory-b ${isActive('inventory')}`} onClick={() => changeActiveComponent('inventory')}>
      <img src={IconInventory} alt="Inventory icon" />
      {renderLabel('inventory', 'INVENTORY')}
    </button>
    <button className={`right-menu-button shop-b ${isActive('shop')}`} onClick={() => changeActiveComponent('shop')}>
      <img src={IconShop} alt="Shop icon" />
      {renderLabel('shop', 'SHOP')}
    </button>
    <button className={`right-menu-button treasury-b ${isActive('treasury')}`} onClick={() => changeActiveComponent('treasury')}>
      <img src={IconGold} alt="Treasury icon" />
      {renderLabel('treasury', 'TREASURY')}
    </button>
    <button className={`right-menu-button incubating-b ${isActive('incubating')}`} onClick={() => changeActiveComponent('incubating')}>
      <img src={IconIncubating} alt="Incubating icon" />
      {renderLabel('incubating', 'INCUBATING')}
    </button>
    <button className={`right-menu-button gathering-b ${isActive('gathering')}`} onClick={() => changeActiveComponent('gathering')}>
      <img src={IconGathering} alt="Gathering icon" />
      {renderLabel('gathering', 'GATHERING')}
    </button>
    <button className={`right-menu-button lottery-b ${isActive('lottery')}`} onClick={() => changeActiveComponent('lottery')}>
      <img src={IconLottery} alt="Lottery icon" />
      {renderLabel('lottery', 'LOTTERY')}
    </button>
    <p className="menu-right-text2">TECHNICAL</p>
    <button id="technical-button" className={`${isActive('settings')}`} onClick={toggleSettings}>
      <img src={settingsIcon} alt="Settings icon" />
      {renderLabel('settings', 'SETTINGS')}
    </button>
    <button id="technical-button" className={`${isActive('news')}`} onClick={toggleNews}>
    <img src={newsIcon} alt="News icon" />
    {renderLabel('news', 'NEWS')}
  </button>
  </div>
  );
}

export default MenuRight;